import deprecatedAccountService from '../services/deprecatedaccount.service';

const deprecatedaccounts = {
    namespaced: true,
    state: {},
    actions: {
        getSet(_, accountIds) {
            return deprecatedAccountService.getSet(accountIds);
        },
        getAgeingAccounts() {
            return deprecatedAccountService.getAgeingAccounts();
        },
    },
    getters: {},
    mutations: {},
};

export default deprecatedaccounts;
